import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { RoomModel, ROOM_TYPES } from 'projects/core/src/lib/models/room.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-room-list',
  templateUrl: './room-list.component.html',
  styleUrls: ['./room-list.component.scss']
})
export class RoomListComponent extends BaseList implements OnInit {

  public rooms: Array<RoomModel> = [];
  public apiUrl = '/rooms';

  protected rightLoad = 'admin.room.list';
  protected rightNew = 'admin.room.create';
  protected rightOpen = 'admin.room.show';

  public roomTypes = ROOM_TYPES;

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.rooms'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('rooms').subscribe({
      next: (rooms: any) => {
        this.rooms = [];
        rooms.data.forEach((room: any) => {
          this.rooms.push(new RoomModel().deserialize(room));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
